"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewFastpass = function NewFastpass() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "22",
    height: "16",
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.9079 15.5C11.8131 15.5 10.0387 14.773 8.58469 13.319C7.13086 11.8652 6.40394 10.0907 6.40394\n7.99575C6.40394 5.91658 7.13086 4.1475 8.58469 2.6885C10.0387 1.2295 11.8131 0.5 13.9079\n0.5C15.9873 0.5 17.7564 1.2295 19.2152 2.6885C20.6742 4.1475 21.4037 5.91658 21.4037\n7.99575C21.4037 10.0907 20.6742 11.8652 19.2152 13.319C17.7564 14.773 15.9873 15.5 13.9079\n15.5ZM13.9037 14C15.5704 14 16.987 13.4167 18.1537 12.25C19.3204 11.0833 19.9037 9.66667 19.9037\n8C19.9037 6.33333 19.3204 4.91667 18.1537 3.75C16.987 2.58333 15.5704 2 13.9037 2C12.237 2 10.8204\n2.58333 9.65369 3.75C8.48702 4.91667 7.90369 6.33333 7.90369 8C7.90369 9.66667 8.48702 11.0833\n9.65369 12.25C10.8204 13.4167 12.237 14 13.9037 14ZM16.2749 11.4653L17.3442 10.3963L14.6537\n7.70575V4.15375H13.1537V8.31925L16.2749 11.4653ZM1.59619 4.75V3.25H5.40394V4.75H1.59619ZM0.596191\n8.75V7.25H5.40394V8.75H0.596191ZM1.59619 12.75V11.25H5.40394V12.75H1.59619Z",
    fill: "#6E6D71"
  }));
};
var _default = NewFastpass;
exports.default = _default;